import { Button } from './ui/Button';

async function clearSiteCachesBestEffort(): Promise<void> {
  // Cache Storage (e.g. SW precache, runtime cache)
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // ignore
  }

  // Service workers
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
    }
  } catch {
    // ignore
  }
}

export async function hardReloadWithCacheBust(): Promise<void> {
  await clearSiteCachesBestEffort();
  const url = new URL(window.location.href);
  url.searchParams.set('__reload', String(Date.now()));
  // Replace to avoid growing history
  window.location.replace(url.toString());
}

export function UpdateRequiredOverlay({ message, onReload }: { message: string; onReload?: () => void }) {
  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-xl">
        <div className="p-5">
          <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Update available
          </div>
          <div className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            {message}
          </div>
          <div className="mt-4 flex justify-end">
            <Button onClick={onReload || hardReloadWithCacheBust}>
              Reload now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

